import Temp from "@/courier/Temp";

export default class CourierInter extends Temp {
  static CODE = "INT";

  constructor() {
    super(CourierInter.CODE);
  }

  listPostcodeSpecial = JSON.parse(localStorage.getItem("courier_postcode"));

//   getZone(item, courier) {
//     if ( courier ) 
//       {
//       let type, from, to;
//       let cross_price = 0;
//       let remote_area = 0;
//       let travel_surcharge = 0;
//       let island_surcharge = 0;

//       remote_area = super.checkRemoteArea(Number(item.toPostcode));
//       travel_surcharge = super.checkTravelSurcharge(Number(item.toPostcode));
//       island_surcharge = super.checkTravelSurcharge(Number(item.toPostcode));

//       if (travel_surcharge) {
//         if (new Date().getTime() > new Date('2023-04-08 00:00:00').getTime()) {
//           if (item.weight > 20000) {
//             travel_surcharge = 200;
//           } else if (item.weight > 7000) {
//             travel_surcharge = 100;
//           } else {
//             travel_surcharge = 30;
//           }
//         } else {
//           if (item.weight > 50000) {
//             travel_surcharge = 150;
//           } else if (item.weight > 30000) {
//             travel_surcharge = 100;
//           } else {
//             travel_surcharge = 50;
//           }
//         }
//       }
//       let prefixFromPostCode = item.fromPostcode.toString().substring(0, 2);
//       let prefixToPostCode = item.toPostcode.toString().substring(0, 2);

//       if (Object.keys(item.courierRates).length < 2) {
//         from = null;
//         to = null;
//       } else {
//         from = super.checkZone(prefixFromPostCode);
//         to = super.checkZone(prefixToPostCode);
//       }
//       if (["94", "95", "96"].indexOf(prefixToPostCode) > -1) {
//         // remote_area = this.listPostcodeSpecial[FlashExpressFruit.CODE].remotearea
//         //   .special.cost;
//       }

//       if (
//         ["94", "95", "96"].indexOf(prefixToPostCode) > -1 &&
//         ["94", "95", "96"].indexOf(prefixFromPostCode) > -1
//       ) {
//         remote_area = 0;
//       }
//       const sameProvince = this.checkSameProvince(item);

//       if ([3, 4, 5, 2].includes(to) && to === from && sameProvince) {
//         if (to == 3) type = 8;
//         if (to == 4) type = 9;
//         if (to == 5) type = 10;
//         if (to == 2) type = 11;
//       } else if (from == 1 && to == 1) {
//         // BKK -> BKK
//         type = 1;
//       } else if (from == 1 && [3, 4, 5, 2].includes(to)) {
//         // BKK -> N, NE, S, C
//         type = 2;
//       } else if ([3, 4, 5, 2].includes(from) && to == 1) {
//         // N, NE, S, C -> BKK
//         type = 3;
//       } else if (from == 3 && [3, 4, 5, 2].includes(to)) {
//         // N -> N, NE, S, C
//         type = 4;
//       } else if (from == 4 && [3, 4, 5, 2].includes(to)) {
//         // NE -> N, NE, S, C
//         type = 5;
//       } else if (from == 5 && [3, 4, 5, 2].includes(to)) {
//         // S -> N, NE, S, C
//         type = 6;
//       } else if (from == 2 && [3, 4, 5, 2].includes(to)) {
//         // C -> N, NE, S, C
//         type = 7;
//       }
//       return {
//         rate_type: type,
//         rate_remote_area: remote_area,
//         travel_surcharge: travel_surcharge,
//         island_surcharge: island_surcharge,
//         cross_price: cross_price,
//       };
//     }
//   }
}
